// Account → Sync: what syncs, when it last did, "Sync now", and deleting the cloud copy.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Body, Button, Caption } from './ui';
import { confirm } from './Dialogs';
import DataFileButtons from './DataFileButtons';
import { deleteCloudCopy, syncNow, useCloud } from '../store/cloud';
import { usePalette } from '../theme';

export default function CloudSyncBox() {
  const { t, i18n } = useTranslation();
  const p = usePalette();
  const { status, lastSyncAt, error } = useCloud();
  const reason = error && i18n.exists(`account.cloud.errors.${error}`) ? t(`account.cloud.errors.${error}` as 'account.cloud.errors.generic') : t('account.cloud.errors.generic');
  return (
    <>
      <Body>
        {status === 'syncing' ? t('account.cloud.syncing') : lastSyncAt ? t('account.cloud.synced', { time: new Date(lastSyncAt).toLocaleString() }) : t('account.cloud.never')}
      </Body>
      {status === 'error' ? <Caption color={p.danger}>{t('account.cloud.failed', { reason })}</Caption> : null}
      <Button label={t('account.cloud.syncNow')} variant="secondary" disabled={status === 'syncing'} onPress={syncNow} />
      <Caption>{t('account.cloud.note')}</Caption>
      <DataFileButtons download={t('account.cloud.download')} upload={t('account.cloud.upload')} />
      <Caption>{t('account.cloud.keep')}</Caption>
      <Button
        label={t('account.cloud.deleteCopy')}
        variant="plain"
        onPress={async () => {
          if (await confirm(t('account.cloud.deleteCopyTitle'), t('account.cloud.deleteCopyBody'))) await deleteCloudCopy().catch(() => {});
        }}
      />
    </>
  );
}
